import {
  GET_LOADING,
  GET_LOCKED_FEATURES,
  GET_AUTO_REFRESH_ENABLED,
  GET_NOTIFIER,
  GET_SELECTOR_PANEL,
  GET_SELECTED_DATES,
  GET_DETAILS_SIDEBAR,
  GET_INFO_VIEWER_ITEMS,
  GET_INFO_VIEWER_REFRESH,
  GET_FIREBASE_ENABLED,
} from "./actions.type";

import {
  SET_LOADING,
  SET_LOCKED_FEATURES,
  SET_AUTO_REFRESH_ENABLED,
  SET_NOTIFIER,
  SET_SELECTOR_PANEL,
  SET_SELECTED_DATES,
  SET_DETAILS_SIDEBAR,
  SET_INFO_VIEWER_ITEMS,
  SET_INFO_VIEWER_REFRESH,
  SET_FIREBASE_ENABLED,
} from "./mutations.type";

import { NOTIFIER_TYPES } from "@/common/constants/misc";

const STATE = {
  loading: false,
  lockedFeatures: null,
  autoRefreshEnabled: true,
  notifier: {
    visible: false,
    seconds: 6,
    type: NOTIFIER_TYPES.info,
    message: null,
  },
  selectorPanel: {
    visible: true,
    selected: null,
    selectedData: null,
    disasters: false,
    travel: false,
    news: false,
    alerts: false,
  },
  selectedDates: {
    start: null,
    end: null,
  },
  detailsSidebar: {
    visible: false,
    selected: null,
    type: null,
    monitorType: null,
    title: null,
    loading: false,
    keywords: null,
    keywordsOnClickFnc: null,
    features: null,
    total: null,
    iconColor: null,
    iconName: null,
    showTime: null,
    openMonitor: false,
    width: 400,
  },
  firebaseEnabled: false,
};

const GETTERS = {
  loading: (state) => state.loading,
  lockedFeatures: (state) => state.lockedFeatures,
  autoRefreshEnabled: (state) => state.autoRefreshEnabled,
  notifier: (state) => state.notifier,
  selectorPanel: (state) => state.selectorPanel,
  selectedDates: (state) => state.selectedDates,
  detailsSidebar: (state) => state.detailsSidebar,
  firebaseEnabled: (state) => state.firebaseEnabled,
};

const ACTIONS = {
  [GET_LOADING](context, data) {
    context.commit(SET_LOADING, data);
  },
  [GET_LOCKED_FEATURES](context, data) {
    context.commit(SET_LOCKED_FEATURES, data);
  },
  [GET_AUTO_REFRESH_ENABLED](context, data) {
    context.commit(SET_AUTO_REFRESH_ENABLED, data);
  },
  [GET_NOTIFIER](context, data) {
    if (!data.visible) {
      data.type = NOTIFIER_TYPES.info;
      data.message = null;
    }
    context.commit(SET_NOTIFIER, data);
  },
  [GET_SELECTOR_PANEL](context, data) {
    context.commit(SET_SELECTOR_PANEL, data);
  },
  [GET_SELECTED_DATES](context, data) {
    context.commit(SET_SELECTED_DATES, data);
  },
  [GET_DETAILS_SIDEBAR](context, data) {
    context.commit(SET_DETAILS_SIDEBAR, data);
  },
  [GET_INFO_VIEWER_ITEMS](context, data) {
    context.commit(SET_INFO_VIEWER_ITEMS, data);
  },
  [GET_INFO_VIEWER_REFRESH](context, data) {
    context.commit(SET_INFO_VIEWER_REFRESH, data);
  },
  [GET_FIREBASE_ENABLED](context, data) {
    context.commit(SET_FIREBASE_ENABLED, data);
  },
};

const MUTATIONS = {
  [SET_LOADING](state, data) {
    state.loading = data;
  },
  [SET_LOCKED_FEATURES](state, data) {
    state.lockedFeatures = data;
  },
  [SET_AUTO_REFRESH_ENABLED](state, data) {
    state.autoRefreshEnabled = data;
  },
  [SET_NOTIFIER](state, data) {
    state.notifier = data;
  },
  [SET_SELECTOR_PANEL](state, data) {
    state.selectorPanel = data;
  },
  [SET_SELECTED_DATES](state, data) {
    state.selectedDates = data;
  },
  [SET_DETAILS_SIDEBAR](state, data) {
    state.detailsSidebar = data;
  },
  [SET_FIREBASE_ENABLED](state, data) {
    state.firebaseEnabled = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
